/**
 * Response of `POST /payments/stripe/user/checkout` and
 * `POST /payments/stripe/user/portal_session`.
 *
 * `url` is single-use and short-lived — redirect the browser to it
 * immediately, never cache it.
 */
export interface WicketStripeSessionResponse {
  id: string;
  url: string;
}
